import { useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { identityServices } from '../identityServices'
import { UpdateUserKycInfoPayload } from '../identityTypes'
import { QUERY_KEYS } from '@/constants/queryKeys'

interface UseUpdateUserKycInfoOptions {
  onSuccess?: () => void
  onError?: (error: { errorMessage?: string; code?: string }) => void
}

export function useUpdateUserKycInfo(options?: UseUpdateUserKycInfoOptions) {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: UpdateUserKycInfoPayload) =>
      identityServices.updateUserKycInfo(data),
    onSuccess: () => {
      // Invalidate cache (same as React Native version)
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.IDENTITY_ME],
      })
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.IDENTITY_KYC_INFO],
      })

      if (options?.onSuccess) {
        options.onSuccess()
      }
    },
    onError: (error: any) => {
      const errorMessage = error?.message || t('api:errors.somethingWrong')

      if (options?.onError) {
        options.onError({ errorMessage })
      }
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  }
}
